document.addEventListener('DOMContentLoaded', function () {
    const metals = [
        {
            selector: '[data-metal="gold"]',
            symbol: 'XAU',
            label: 'GOLD'
        },
        {
            selector: '[data-metal="silver"]',
            symbol: 'XAG',
            label: 'SILVER'
        },
        {
            selector: '[data-metal="platinum"]',
            symbol: 'XPT',
            label: 'PLATINUM'
        }
    ];

    metals.forEach(function (metal) {
        const elements = document.querySelectorAll(metal.selector);
        if (!elements.length) return;

        fetch(`https://api.gold-api.com/price/${metal.symbol}`)
            .then(response => response.json())
            .then(data => {
                if (data && data.price) {
                    const pricePerOunce = data.price;
                    const pricePerGram = pricePerOunce / 31.1035;

                    const formattedPricePerOunce = pricePerOunce.toFixed(2);
                    const formattedPricePerGram = pricePerGram.toFixed(2);

                    const text = `${metal.label} $${formattedPricePerOunce}/oz • $${formattedPricePerGram}/g`;

                    elements.forEach(function (element) {
                        element.textContent = text;
                    });
                } else {
                    elements.forEach(function (element) {
                        element.textContent = `${metal.label} unavailable`;
                    });
                }
            })
            .catch(function () {
                elements.forEach(function (element) {
                    element.textContent = `${metal.label} unavailable`;
                });
            });
    });
});